<template>
  <b-button class="cancel" @click="act" size="is-large" type="is-white"
    >Cancel</b-button
  >
</template>

<script>
import { bus } from "@/components/spaces/bus.js";

export default {
  methods: {
    act() {
      bus.$emit("cancelling-event");
    },
  },
};
</script>
